import {
  Box, Skeleton, useTheme,
} from '@mui/material';

export function WalletSmallInfoCardSkeleton() {
  const theme = useTheme();

  return (
    <Box
      id={'skeleton-card'}
      sx={{
        display: 'flex',
        padding: `${theme.spacing(1.875)} ${theme.spacing(2.5)}`,
        flexDirection: 'column',
        alignItems: 'flex-start',
        flex: '1 0 0',
        borderRadius: theme.spacing(1.5),
        border: `1px solid ${theme.palette.grey[200]}`,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          alignSelf: 'stretch',
          mb: theme.spacing(1.875),
        }}
      >
        <Skeleton animation="wave" height={20} width="50%" />
        <Skeleton
          variant="circular"
          animation="wave"
          width={theme.spacing(2.5)}
          height={theme.spacing(2.5)}
        />
      </Box>
      <Skeleton animation="wave" height={40} width="50%" sx={{ mb: theme.spacing(0.625) }} />
    </Box>
  );
}
